import { NgModule } from '@angular/core';
import { FormatDateTimePipe } from './formatDateTime.pipe';

@NgModule({
  declarations: [FormatDateTimePipe],
  exports: [FormatDateTimePipe]
})
export class PipeModule { } 



// WEBPACK FOOTER //
// /app/SPA/src/app/pipes/pipe.module.ts